<div class="reassign-tech">

  <div class="ui-g-12 p-zero dialog-header">
    <div class="columns">
      <div class="text">
        <div class="font-18 font-bold black mt-2 tml-heading">Reassign self as</div>
      </div>
      <div class="close">
        <i class="fal fa-times fa-sm dialog-close font-500" (click)="closeDuplicateVehicleeModal({})"></i>
      </div>
    </div>
  </div>

  <div class="dialog-body">
    <div class="ui-g">

      <!-- Primary tech -->
      <div class="ui-g-12 vehicle-card-title">
        <div class="columns">
          <div class="checkbox-vin">
            <app-radio-button [value]="selected" (appChange)="handleRadioChange($event,'primary')" [selectedValue]="primary"></app-radio-button>
          </div>
          <div class="vin">
            <p class="m-0 font-16 font-700 black tml-heading">Primary tech</p>
            <p class="m-0 font-16 font-gray-45 tml-heading text-truncate">Replace {{service?.tech?.name}}</p>
            <p class="m-0 font-14 font-red tml-heading" *ngIf="primaryTechInprogress">{{service?.tech?.name}} is currently working on this service.</p>

          </div>
        </div>
      </div>

       <!-- Helper 1 tech -->
       <div class="ui-g-12 vehicle-card-title">
        <div class="columns">
          <div class="checkbox-vin">
            <app-radio-button [value]="selected" (appChange)="handleRadioChange($event,'helper1')" [selectedValue]="helper1"></app-radio-button>
          </div>
          <div class="vin">
            <p class="m-0 font-16 font-700 black tml-heading">Helper 1</p>
            <p class="m-0 font-16  font-gray-45 tml-heading text-truncate">Replace {{service?.hTechOne?.name}}</p>
            <p class="m-0 font-14  font-red tml-heading" *ngIf="hOneTechInprogress">{{service?.hTechOne?.name}} is currently working on this service</p>
          </div>
        </div>
      </div>

       <!-- Helper 2 tech -->
       <div class="ui-g-12 vehicle-card-title">
        <div class="columns">
          <div class="checkbox-vin">
            <app-radio-button  [value]="selected" (appChange)="handleRadioChange($event,'helper2')" [selectedValue]="helper2"></app-radio-button>
          </div>
          <div class="vin">
            <p class="m-0 font-16 font-700 black tml-heading">Helper 2</p>
            <p class="m-0 font-16  font-gray-45 tml-heading text-truncate">Replace {{service?.hTechTwo?.name}}</p>
            <p class="m-0 font-14  font-red tml-heading" *ngIf="hTwoTechInprogress">{{service?.hTechTwo?.name}} is currently working on this service</p>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="p-zero text-center reassign-footer" >
      <button id="btn-cancel" class="btn btn-white pointer btn-submit"
      (click)="closeDuplicateVehicleeModal({})">Cancel
    </button>
      <button id="btn-save" [disabled]="!primary && !helper1 && !helper2" class="btn btn-primary btn-submit"
        (click)="handleSubmit()">Confirm
      </button>

    </div>
  </div>

  </div>
